/* eslint jsx-a11y/click-events-have-key-events:0 jsx-a11y/no-noninteractive-element-interactions:0 */
import React, { useState, useEffect } from "react";
import logo from "../../assets/fvd-logo.png";
import cart from "../../assets/shopping-cart.svg";
import cartWhite from "../../assets/shopping-cart.png";
import { Link } from "gatsby";
import MenuIcon from "../../assets/menu-icon.png"
import CloseIcon from "../../assets/close.png"
import Badge from '@material-ui/core/Badge';
import { getCart } from '../../utils/cart';

import {
  Container,
  Logo,
  WebViewMenu,
  Ul,
  Li,
  MainButton,
  Cart,
  MobileMenu,
  MobileMenuContainer
} from "./Components";

const data = [
  {
    id: 1,
    text: "A Feira e o Dão",
    url: "/about",
  },
  {
    id: 2,
    text: "Programa",
    url: "/program",
  },
  {
    id: 3,
    text: "Rota dos Produtores",
    url: "/map",
  },
  {
    id: 4,
    text: "Contactos",
    url: "/contact",
  },
];

const Navbar = () => {

  const [mobileMenu, setMobileMenu] = useState(false);

  useEffect(() => {
    document.body.style.overflow = mobileMenu ? 'hidden' : 'unset';
  }, [mobileMenu]);

  const toogleMobileMenu = () => {
    const last = mobileMenu;
    setMobileMenu(!last)
  }

  let areThereProducts = undefined;

  try {
    const shoppingCart = getCart();
    areThereProducts = shoppingCart === null ? false : (shoppingCart.products && shoppingCart.products.length !== 0) ? true : false;
  } catch (e) {
    areThereProducts = false;
  }


  return (
    <Container>
      <Link to="/">
        <Logo src={logo} alt="logo" />
      </Link>
      <MobileMenu onClick={toogleMobileMenu}>
        <img style={{ width: '27px', height: '16px' }} src={MenuIcon} alt="menu-icon" />
      </MobileMenu>
      <WebViewMenu>
        <Ul>
          {data.map(link => {
            return (
              <Li key={link.id}>
                <Link
                  style={{
                    textDecoration: 'none',
                    whiteSpace: 'nowrap',
                    color: '#696969',
                    fontWeight: '400',
                    '&:hover': {
                      color: '#B6936C',
                    }
                  }}
                  to={link.url}
                >
                  {link.text}
                </Link>
              </Li>
            );
          })}
        </Ul>
        <Link to={`/#store`}>
          <MainButton>
            LOJA
          </MainButton>
        </Link>
        <Link to="/resume"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <Badge
            variant="dot"
            color="error"
            invisible={!areThereProducts}
            classes={{
              badge: 'badge-shopping-cart-main'
            }}
          >
            <Cart src={cart} alt="cart" />
          </Badge>
        </Link>
      </WebViewMenu>
      {mobileMenu &&
        <MobileMenuContainer>
          <img
            onClick={toogleMobileMenu}
            src={CloseIcon}
            alt="close-icon"
            style={{ margin: '20px 20px 20px auto', display: 'block' }}
          />
          <Ul mobile>
            <Li>
              <Link
                style={{
                  textDecoration: 'none',
                  whiteSpace: 'nowrap',
                  color: 'white',
                  fontWeight: '400',
                  fontSize: '22px',
                }}
                onClick={toogleMobileMenu}
                to={`/#store`}
              >
                Loja Online
              </Link>
            </Li>
            {data.map(link => {
              return (
                <Li key={link.id}>
                  <Link
                    style={{
                      textDecoration: 'none',
                      whiteSpace: 'nowrap',
                      color: 'white',
                      fontWeight: '400',
                      fontSize: '22px',
                    }}
                    to={link.url}
                    onClick={toogleMobileMenu}
                  >
                    {link.text}
                  </Link>
                </Li>
              );
            })}
          </Ul>
          <Link to="/resume" onClick={toogleMobileMenu}>
            <div style={{ margin: '20px', textAlign: 'right' }}>
              <Badge
                variant="dot"
                invisible={!areThereProducts}
                classes={{
                  badge: 'badge-shopping-cart-white'
                }}
              >
                <img src={cartWhite} alt="cart-mobile" />
              </Badge>
            </div>
          </Link>
        </MobileMenuContainer>
      }
    </Container>
  );
};

export default Navbar;
